import { Shield, Wrench, Package } from "lucide-react";

const CATS = [
  { id: "security", Icon: Shield, title: "Security Services", color: "text-sky-400 border-sky-500/40",
    roles: ["Security Guards", "Bouncers", "Security Supervisors", "Ex-Serviceman Guards"], note: "Height, weight & licence details captured at registration" },
  { id: "skilled", Icon: Wrench, title: "Skilled Labour", color: "text-emerald-400 border-emerald-500/40",
    roles: ["Machine Operators", "Electricians", "Welders", "Technicians"], note: "UAN captured for existing PF accounts" },
  { id: "unskilled", Icon: Package, title: "Unskilled Labour", color: "text-amber-400 border-amber-500/40",
    roles: ["Housekeeping", "Trolley Boys", "Loaders", "Helpers & Ushers"], note: "Bulk deployment for malls, cinemas & warehouses" },
];

export const Services = () => (
  <section id="services" className="scroll-mt-20 bg-[#0B1120] py-20 lg:py-28">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="eyebrow">Service categories</p>
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-white lg:text-3xl">Three cadres. One request flow.</h2>
      </div>
      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
        {CATS.map(({ id, Icon, title, color, roles, note }) => (
          <article key={id} data-testid={`category-badge-${id}`} className="group rounded-2xl border border-white/10 bg-[#0F172A] p-5 transition-transform duration-300 hover:-translate-y-1">
            <span className={`inline-flex h-10 w-10 items-center justify-center rounded-xl border ${color}`}><Icon className="h-5 w-5" /></span>
            <h3 className="mt-4 font-heading text-lg font-bold text-white">{title}</h3>
            <ul className="mt-3 space-y-1.5 text-sm">
              {roles.map((r) => (
                <li key={r} className="flex items-center gap-2.5 text-slate-300"><span className="h-1 w-3 rounded-full bg-orange-500" />{r}</li>
              ))}
            </ul>
            <p className="mt-4 border-t border-white/10 pt-3 text-xs leading-relaxed text-slate-500">{note}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
